import { render, staticRenderFns } from "./wxpay_jsapi.vue?vue&type=template&id=4b906363&scoped=true&"
import script from "./wxpay_jsapi.vue?vue&type=script&lang=js&"
export * from "./wxpay_jsapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b906363",
  null
  
)

export default component.exports